import Indentification from "../../../../elements/Indentification";
import { initialsValue } from "../../../../../helpers";

const LeftAvatar = ({ src, alt }) => {
  return (
    <div className="relative flex-none hidden w-10 h-10 mr-4 chat-text-box__photo sm:block image-fit">
      <Indentification image={src} alt={alt} initial={initialsValue(alt)} />
    </div>
  );
};

export default LeftAvatar;
